import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 update_tenant_product_price: { message: "idle" },
};

export const update_tenant_product_price_Slice = createSlice({
 name: "update_tenant_product_price",
 initialState,
 reducers: {
  success_update_tenant_product_price: (state, action) => {
   state.update_tenant_product_price = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_update_tenant_product_price: (state, action) => {
   state.update_tenant_product_price = { status: app_consts.FAIL, message: action.payload };
  },
  reset_update_tenant_product_price: (state) => {
   state.update_tenant_product_price = { status: app_consts.IDLE };
  },
  loading_update_tenant_product_price: (state) => {
   state.update_tenant_product_price = { status: app_consts.LOADING };
  },
 }
});

export const { success_update_tenant_product_price, fail_update_tenant_product_price, reset_update_tenant_product_price, loading_update_tenant_product_price } = update_tenant_product_price_Slice.actions;

export default update_tenant_product_price_Slice.reducer;